export const isEmpty = (obj: any) => obj && Object.entries(obj).length === 0
